// test2491
(2491 && 0);
